import $api from "../api";

export const state = {};

export const actions = {
    getYears({ rootGetters }) {
        return new Promise(function (resolve) {
            $api
                .get('archive/years', {
                    headers: { Authorization: rootGetters["auth/bearer_token"] },
                })
                .then(function (res) {
                    if (res.status == 200) resolve(res.data);
                })
                .catch(function (err) {
                    if (!err.response) { resolve({ data: [] }); return; }
                    resolve({ data: [] });
                });
        });
    },
    getList({ rootGetters }, pl) {
        return new Promise(function (resolve) {
            $api
                .get('wingbands?' + new URLSearchParams(pl).toString(), {
                    headers: { Authorization: rootGetters["auth/bearer_token"] },
                })
                .then(function (res) {
                    if (res.status == 200) resolve(res.data.data);
                })
                .catch(function (err) {
                    if (!err.response) { resolve({ data: [], total: 0 }); return; }
                    if (err.response.status === 404) {
                        resolve({ data: [], links: [], current_page: 1, last_page: 1, per_page: pl.limit || 10, total: 0 });
                        return;
                    }
                    resolve({ data: [], total: 0 });
                });
        });
    },
    archiveByYear({ rootGetters }, pl) {
        return new Promise(function (resolve) {
            $api
                .post('archive/by-year', pl, {
                    headers: { Authorization: rootGetters["auth/bearer_token"] },
                })
                .then(function (res) {
                    if (res.status == 200 || res.status == 201) resolve(res.data);
                })
                .catch(function (err) {
                    if (!err.response) { resolve(null); return; }
                    resolve(err.response.data);
                });
        });
    },
    restore({ rootGetters }, pl) {
        return new Promise(function (resolve) {
            $api
                .post('archive/restore/' + pl.id, {}, {
                    headers: { Authorization: rootGetters["auth/bearer_token"] },
                })
                .then(function (res) {
                    if (res.status == 200 || res.status == 201) resolve(res.data);
                })
                .catch(function (err) {
                    if (!err.response) { resolve(null); return; }
                    resolve(err.response.data);
                });
        });
    },
    bulkRestore({ rootGetters }, pl) {
        return new Promise(function (resolve) {
            $api
                .post('archive/bulk-restore', pl, {
                    headers: { Authorization: rootGetters["auth/bearer_token"] },
                })
                .then(function (res) {
                    if (res.status == 200 || res.status == 201) resolve(res);
                })
                .catch(function (err) {
                    if (!err.response) { resolve(null); return; }
                    resolve(err.response);
                });
        });
    },
    archiveSingle({ rootGetters }, pl) {
        return new Promise(function (resolve) {
            $api
                .post('wingband/archive/' + pl.id, pl, {
                    headers: { Authorization: rootGetters["auth/bearer_token"] },
                })
                .then(function (res) {
                    if (res.status == 200 || res.status == 201) resolve(res.data);
                })
                .catch(function (err) {
                    if (!err.response) { resolve(null); return; }
                    resolve(err.response.data);
                });
        });
    },
};

export const mutations = {};
export const getters = {};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
